import * as React from 'react';

import {ButtonGroup} from 'shells/button-group/button-group';

import {GetLead} from '../get-lead';

import {HotButton} from './buttons/hot-button';
import {LeadStatusButton} from './buttons/lead-status-button';
import {WatchButton} from './buttons/watch-button';
import {LeadActionMenu} from './lead-action-menu';

import styles from './lead-buttons.module.css';

type Props = {
    leadId: string;
};

export class LeadButtons extends React.PureComponent<Props> {
    render() {
        const {leadId} = this.props;

        return (
            <GetLead leadId={leadId}>
                {/* @ts-expect-error */}
                {({lead}) => {
                    if (!lead) return null;

                    return (
                        <div className={styles['lead-buttons']}>
                            <ButtonGroup>
                                <LeadStatusButton lead={lead} />
                                {NutClientConfig.hasLeadWatching ? (
                                    <WatchButton lead={lead} />
                                ) : undefined}
                                {NutClientConfig.hasHotLeads ? (
                                    <HotButton lead={lead} />
                                ) : undefined}
                                <LeadActionMenu lead={lead} />
                            </ButtonGroup>
                            {(lead.status === 'LOST' || lead.status === 'CANCELLED') &&
                            lead.outcome ? (
                                <div className={styles['outcome-text']}>{lead.outcome.name}</div>
                            ) : undefined}
                        </div>
                    );
                }}
            </GetLead>
        );
    }
}
